import { useCallback, useMemo, useState, useTransition } from 'react';
import { useMinLoadingState } from '@frameio/vapor';

type Options<T> = {
  activeEntity: T;
};

type Callback = () => void;

export function useTransitionActivation<T>({ activeEntity }: Options<T>) {
  const [isPending, startTransition] = useTransition();
  const [pending, setPending] = useState<T | null>(null);

  const isPendingVisible = useMinLoadingState(isPending, 400);

  const activate = useCallback((id: T, fn: Callback) => {
    setPending(id);
    startTransition(fn);
  }, []);

  const state = isPending && pending ? pending : activeEntity;

  const context = useMemo(() => {
    return {
      state,
      activate,
    };
  }, [activate, state]);

  return {
    context,
    isPending: isPendingVisible,
  };
}
